<app-breadcrumb [title]="'Programación de Capacitaciones'" [items]="['Capacitaciones']" [active_item]="'Programación'">
</app-breadcrumb>

<div class="container-fluid">

  <!-- Tarjetas resumen -->
  <div class="row g-3 mb-3" *ngIf="!loading">
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--total">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-calendar stat-card__icon"></i>
          <div>
            <div class="stat-card__value">{{ totalProgramaciones }}</div>
            <div class="stat-card__label">Programaciones registradas</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--activos">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-check-circled stat-card__icon"></i>
          <div>
            <div class="stat-card__value">{{ totalProgramacionesActivas }}</div>
            <div class="stat-card__label">Programaciones activas</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 stat-card stat-card--vigente">
        <div class="card-body d-flex align-items-center">
          <i class="icofont icofont-clock-time stat-card__icon"></i>
          <div>
            <div class="stat-card__value">
              {{ proximaProgramacion ? (proximaProgramacion.fecha_inicio | date:'dd/MM') : '—' }}
            </div>
            <div class="stat-card__label">
              {{ proximaProgramacion ? 'Próxima programación' : 'Sin próximas programaciones' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm border-0">
    <div class="card-header d-flex align-items-center justify-content-between bg-primary text-white">
      <div class="d-flex align-items-center">
        <i class="icofont icofont-calendar me-2"></i>
        <h5 class="mb-0"><strong>PROGRAMACIÓN DE CAPACITACIONES</strong></h5>
      </div>
    </div>

    <div class="card-body custom-datatable noscroll">
      <!-- FILTROS -->
      <div class="row mb-3">
        <div class="col-sm-12 col-md-3">
          <ng-select [items]="[
              { value: 'all',      label: 'Todos'     },
              { value: 'active',   label: 'Activos'   },
              { value: 'inactive', label: 'Inactivos' }
            ]" bindLabel="label" bindValue="value" [(ngModel)]="stateFilter" (change)="page = 1; filterData()"
            [clearable]="false">
          </ng-select>
        </div>

        <div class="col-sm-12 col-md-3 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar..." [(ngModel)]="searchText"
              (input)="filterData()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <!-- TABLA -->
      <div class="custom-datatable table-responsive mt-4" *ngIf="!loading; else skeleton">
        <table class="table table-hover table-bordered align-middle" id="tblProgramaciones">
          <thead class="bg-primary">
            <tr>
              <th class="text-center" style="cursor: pointer" (click)="sortData('nombre')">
                <strong>CAPACITACIÓN</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'nombre' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'nombre'
                  }"></i>
              </th>

              <th class="text-center" style="cursor: pointer" (click)="sortData('fecha')">
                <strong>FECHA INICIO</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'fecha' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'fecha' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'fecha'
                  }"></i>
              </th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('fecha')">
                <strong>FECHA FINAL</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'fecha' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'fecha' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'fecha'
                  }"></i>
              </th>

              <th class="text-center"><strong>LUGAR</strong></th>
              <th class="text-center"><strong>INSTRUCTOR</strong></th>

              <th class="text-center" style="cursor: pointer" (click)="sortData('estado')">
                <strong>ESTADO</strong>
                <i class="fa" [ngClass]="{
                    'fa-sort-up':   sortColumn === 'estado' && sortDirection === 'asc',
                    'fa-sort-down': sortColumn === 'estado' && sortDirection === 'desc',
                    'fa-sort':      sortColumn !== 'estado'
                  }"></i>
              </th>

              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let programacion of filteredTableItems
                | paginate: { itemsPerPage: pageSize, currentPage: page }">

              <td class="text-uppercase">
                {{ programacion.capacitacion?.nombre || "-" }}
              </td>

              <td class="text-center">
                {{ programacion.fecha_inicio | date: "dd/MM/yyyy" }}
              </td>

              <td class="text-center">
                {{ programacion.fecha_final | date: "dd/MM/yyyy" }}
              </td>

              <td class="text-uppercase">
                {{ programacion.lugar || "-" }}
              </td>

              <td class="text-uppercase">
                {{ programacion.instructor || "-" }}
              </td>

              <td class="text-center">
                <span class="badge" [ngClass]="esActivo(programacion) ? 'bg-success' : 'bg-secondary'">
                  {{ esActivo(programacion) ? "Activo" : "Inactivo" }}
                </span>
              </td>

              <td class="text-center">
                <div class="d-flex justify-content-center gap-1 flex-wrap">
                  <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                    ngbTooltip="Asistentes / Invitados" (click)="verAsistentes(programacion, asistentesModal)">
                    <i class="icofont icofont-business-man-alt-2" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded" ngbTooltip="Actividades"
                    (click)="verActividades(programacion)">
                    <i class="icofont icofont-eye" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                    ngbTooltip="Copiar link de asistencia" (click)="copiarLinkInvitacionProgramacion(programacion)">
                    <i class="fa fa-link" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded" *ngIf="esActivo(programacion)"
                    ngbTooltip="Editar" (click)="abrirModalProgramacion(programacionModal, programacion)">
                    <i class="icon-pencil-alt" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                    *ngIf="esActivo(programacion)" ngbTooltip="Inactivar"
                    (click)="inactivarProgramacion(programacion.id)">
                    <i class="icon-trash" style="font-size: .85rem;"></i>
                  </button>

                  <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                    *ngIf="!esActivo(programacion)" ngbTooltip="Activar" (click)="activarProgramacion(programacion.id)">
                    <i class="icon-check-box" style="font-size: .85rem;"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINACIÓN -->
      <div class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <label for="pageSize" class="me-2">Mostrar:</label>
          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary"><b>{{ filteredTableItems?.length }}</b></a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <!-- BOTONES EXPORTAR / CREAR -->
      <div class="mt-4">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button"
            (click)="exportarExcel('tblProgramaciones', 'Listado_programaciones')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>

          <button class="btn btn-outline-danger-2x" type="button"
            (click)="exportToPDF('tblProgramaciones', 'Listado_programaciones', 'Listado de Programaciones de Capacitaciones')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>

          <button class="btn btn-outline-primary-2x" type="button" (click)="abrirModalProgramacion(programacionModal)">
            <i class="fa fa-plus"></i> CREAR
          </button>
        </div>
      </div>

      <!-- SKELETON -->
      <ng-template #skeleton>
        <div class="skeleton-table my-3">
          <table class="table table-hover table-bordered">
            <thead>
              <tr>
                <th *ngFor="let col of [1,2,3,4,5,6,7,8]">
                  <div class="skeleton skeleton-th"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of [].constructor(5)">
                <td *ngFor="let col of [1,2,3,4,5,6,7,8]">
                  <div class="skeleton skeleton-td"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>

      <ng-template #programacionModal let-modal>
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title mb-0">
            <strong>{{ modoEdicionProgramacion ? "EDITAR PROGRAMACIÓN" : "NUEVA PROGRAMACIÓN" }}</strong>
          </h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>

        <div class="modal-body">

          <div class="form-section">
            <div class="form-section__title"><i class="fa fa-info-circle me-1"></i>Información general</div>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label text-dark"><strong>Capacitación:</strong><a class="text-danger"> *</a></label>
                <ng-select [items]="capacitaciones" bindLabel="nombre" bindValue="id"
                  [(ngModel)]="programacionForm.capacitacion_id" placeholder="Seleccione..." [clearable]="false">
                </ng-select>
              </div>

              <div class="col-md-4">
                <label class="form-label text-dark"><strong>Modalidad:</strong><a class="text-danger"> *</a></label>
                <ng-select [items]="Modalidades" bindLabel="label" bindValue="value" placeholder="Seleccione una opción"
                  [(ngModel)]="programacionForm.modalidad">
                </ng-select>
              </div>

              <div class="col-md-4">
                <label class="form-label text-dark"><strong>Instructor:</strong><a class="text-danger"> *</a></label>
                <input type="text" class="form-control text-uppercase" placeholder="Ej. Juan Pérez"
                  [(ngModel)]="programacionForm.instructor" />
              </div>

              <div class="col-md-4" *ngIf="programacionForm.modalidad === 2 || programacionForm.modalidad === 3">
                <label class="form-label text-dark"><strong>Lugar:</strong><a class="text-danger"> *</a></label>
                <input type="text" class="form-control text-uppercase" placeholder="Ej. Auditorio Principal"
                  [(ngModel)]="programacionForm.lugar" />
              </div>

              <div class="col-md-4" *ngIf="programacionForm.modalidad === 1 || programacionForm.modalidad === 3">
                <label class="form-label text-dark"><strong>URL:</strong><a class="text-danger"> *</a></label>
                <input type="url" class="form-control" placeholder="https://..." [(ngModel)]="programacionForm.url" />
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="form-section__title"><i class="fa fa-calendar me-1"></i>Fechas</div>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label text-dark"><strong>Fecha inicio:</strong><a class="text-danger"> *</a></label>
                <input type="date" class="form-control" [(ngModel)]="programacionForm.fecha_inicio" />
              </div>

              <div class="col-md-6">
                <label class="form-label text-dark"><strong>Fecha fin:</strong><a class="text-danger"> *</a></label>
                <input type="date" class="form-control" [min]="programacionForm.fecha_inicio"
                  [(ngModel)]="programacionForm.fecha_final" />
              </div>
            </div>
          </div>

          <div class="form-section" *ngIf="!modoEdicionProgramacion">
            <div class="form-section__title d-flex justify-content-between align-items-center">
              <span><i class="fa fa-users me-1"></i>Invitados</span>
            </div>

            <label class="form-label text-dark"><strong>Agregar invitado por cédula:</strong></label>
            <div class="input-group">
              <input class="form-control" type="number" placeholder="Ingrese el número de documento"
                [(ngModel)]="cedulaBuscada" [disabled]="buscandoInvitado" (keyup.enter)="buscarInvitadoPorCedula()" />
              <button class="btn btn-outline-primary" type="button" [disabled]="buscandoInvitado"
                (click)="buscarInvitadoPorCedula()">
                <i class="fa fa-search" *ngIf="!buscandoInvitado"></i>
                <span *ngIf="buscandoInvitado" class="spinner-border spinner-border-sm"></span>
              </button>
            </div>

            <div class="border border-warning rounded p-3 mt-2" *ngIf="personaNoEncontrada">
              <p class="text-warning mb-2">
                <i class="fa fa-exclamation-triangle me-1"></i>
                No se encontró ninguna persona con esa cédula. Puedes agregarla manualmente:
              </p>
              <div class="row g-2">
                <div class="col-md-4">
                  <input type="number" class="form-control" placeholder="Cédula"
                    [(ngModel)]="nuevoInvitadoManual.cedula" />
                </div>
                <div class="col-md-5">
                  <input type="text" class="form-control text-uppercase" placeholder="Nombre completo"
                    [(ngModel)]="nuevoInvitadoManual.nombre" />
                </div>
                <div class="col-md-3 d-flex">
                  <button class="btn btn-success me-2" type="button" (click)="agregarInvitadoManual()">
                    <i class="fa fa-plus"></i> Agregar
                  </button>
                  <button class="btn btn-outline-secondary" type="button"
                    (click)="cancelarAgregarManual()">Cancelar</button>
                </div>
              </div>
            </div>

            <div class="mt-3" *ngIf="invitadosSeleccionados.length > 0">
              <h6 class="mb-3 text-dark">Invitados agregados:</h6>
              <table class="table table-sm table-bordered mb-0">
                <thead class="bg-primary text-white">
                  <tr>
                    <th>N° Documento</th>
                    <th>Nombre</th>
                    <th width="80" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let inv of invitadosSeleccionados">
                    <td>{{ inv.cedula }}</td>
                    <td class="text-uppercase">{{ inv.nombre }}</td>
                    <td class="text-center">
                      <button class="btn btn-sm btn-danger" type="button" (click)="eliminarInvitado(inv.cedula)">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="form-section">
            <div class="form-section__title"><i class="fa fa-comment me-1"></i>Observaciones</div>
            <textarea rows="4" class="form-control" [(ngModel)]="programacionForm.observaciones"></textarea>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
          <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarProgramacion()">
            <span *ngIf="!loading">{{ modoEdicionProgramacion ? "Actualizar" : "Guardar" }}</span>
            <span *ngIf="loading">Guardando...</span>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<ng-template #asistentesModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0">
      <strong>
        ASISTENTES
        <span *ngIf="selectedProgramacionCapacitacionNombre">
          – {{ selectedProgramacionCapacitacionNombre }}
        </span>
      </strong>
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <!-- TABS -->
    <ul class="nav nav-tabs mb-3" role="tablist">
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" [class.active]="modalAsistentesTab === 'invitados'"
          (click)="modalAsistentesTab = 'invitados'">
          <i class="icofont icofont-ui-user-group me-1"></i>Invitados
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:void(0)" [class.active]="modalAsistentesTab === 'asistentes'"
          (click)="modalAsistentesTab = 'asistentes'">
          <i class="icofont icofont-business-man-alt-2 me-1"></i>Asistentes
        </a>
      </li>
    </ul>

    <!-- ===================== TAB INVITADOS ===================== -->
    <div *ngIf="modalAsistentesTab === 'invitados'">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h6 class="mb-0 text-dark"><strong>INVITADOS</strong></h6>
        <button class="btn btn-outline-primary btn-sm" type="button"
          (click)="abrirModalAgregarInvitados(agregarInvitadosModal)">
          <i class="fa fa-plus"></i> Agregar invitado
        </button>
      </div>

      <div class="custom-datatable table-responsive">
        <table class="table table-hover table-bordered" id="tblInvitados">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>N° DOCUMENTO</strong></th>
              <th class="text-center"><strong>NOMBRE</strong></th>
              <th class="text-center"><strong>ASISTIÓ</strong></th>
              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let invitado of invitadosProgramacion">
              <td class="text-center">{{ invitado.propietario_id || "-" }}</td>
              <td class="text-center text-uppercase">{{ invitado.nombre || "-" }}</td>
              <td class="text-center">
                <span class="badge" [ngClass]="invitado.asistio == 1 ? 'bg-success' : 'bg-danger'">
                  {{ invitado.asistio == 1 ? "Sí" : "No" }}
                </span>
              </td>
              <td class="text-center">
                <div class="action">
                  <ul class="list-inline m-0">

                    <!-- BOTÓN: Quitar invitado -->
                    <li class="delete list-inline-item" (click)="quitarInvitado(invitado)">
                      <a href="javascript:void(0)">
                        <i class="icon-trash" ngbTooltip="Quitar invitado"></i>
                      </a>
                    </li>

                  </ul>
                </div>
              </td>
            </tr>

            <tr *ngIf="!loadingInvitados && invitadosProgramacion.length === 0">
              <td colspan="4" class="text-center text-primary py-4">
                No hay invitados registrados para esta capacitación.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-center flex-grow-1 mb-2">
        Total Registros:
        <a class="badge badge-primary"><b>{{ invitadosProgramacion?.length }}</b></a>
      </div>
    </div>

    <!-- ===================== TAB ASISTENTES ===================== -->
    <div *ngIf="modalAsistentesTab === 'asistentes'">
      <div class="custom-datatable table-responsive mt-2">
        <table class="table table-hover table-bordered" id="tblAsistencias">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>CAPACITACIÓN</strong></th>
              <th class="text-center"><strong>N° DOCUMENTO</strong></th>
              <th class="text-center"><strong>NOMBRE</strong></th>
              <th class="text-center"><strong>ASISTIÓ</strong></th>
              <th class="text-center"><strong>APROBADO</strong></th>
              <th class="text-center"><strong>CALIFICACIÓN</strong></th>
              <th class="text-center"><strong>ACCIONES</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let asistentes of filteredTableItemsAsistencia
                | paginate: { itemsPerPage: pageSize, currentPage: page }">
              <td class="text-uppercase">
                {{ selectedProgramacionCapacitacionNombre || "-" }}
              </td>
              <td class="text-center">{{ asistentes.cedula || "-" }}</td>
              <td class="text-uppercase">{{ asistentes.nombre || "-" }}</td>
              <td class="text-center">
                <span class="badge" [ngClass]="asistioLabel(asistentes) ? 'bg-success' : 'bg-danger'">
                  {{ asistioLabel(asistentes) ? "Sí" : "No" }}
                </span>
              </td>
              <td class="text-center">
                <span class="badge" [ngClass]="aprobadoLabel(asistentes) ? 'bg-success' : 'bg-danger'">
                  {{ aprobadoLabel(asistentes) ? "Sí" : "No" }}
                </span>
              </td>
              <td class="text-center">{{ asistentes.calificacion ?? "-" }}</td>
              <td class="text-center">
                <div class="action">
                  <ul class="list-inline m-0">
                    <li class="edit list-inline-item"
                      (click)="abrirModalEditarAsistente(asistentes, editAsistenciaModal)">
                      <a href="javascript:void(0)">
                        <i class="icon-pencil-alt" ngbTooltip="Editar"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>

            <tr *ngIf="!loading && filteredTableItemsAsistencia.length === 0">
              <td colspan="7" class="text-center text-primary py-4">
                No hay asistentes registrados para esta capacitación.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginación asistentes -->
      <div class="d-flex justify-content-between align-items-center mt-4">
        <div class="d-flex align-items-center">
          <label for="pageSize" class="me-2">Mostrar:</label>
          <select id="pageSize" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <div class="text-center flex-grow-1">
          Total Registros:
          <a class="badge badge-primary">
            <b>{{ filteredTableItemsAsistencia?.length }}</b>
          </a>
        </div>

        <div class="text-end paginador-personalizado">
          <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>

      <!-- Botones asistentes -->
      <div class="mt-4" *ngIf="!modoEmbebido">
        <div class="btn-showcase text-center">
          <button class="btn btn-outline-success-2x" type="button"
            (click)="exportarExcel('tblAsistencias', 'Listado_asistencias')">
            <i class="icofont icofont-file-excel"></i> EXCEL
          </button>
          <button class="btn btn-outline-danger-2x" type="button"
            (click)="exportToPDF('tblAsistencias', 'Listado_asistencias', 'Listado de Asistencias a Capacitaciones')">
            <i class="icofont icofont-file-pdf"></i> PDF
          </button>
          <button class="btn btn-outline-primary-2x" type="button"
            (click)="abrirModalNuevoAsistente(createAsistenciaModal)">
            <i class="fa fa-plus"></i> CREAR
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>

<ng-template #editAsistenciaModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0"><strong>EDITAR ASISTENCIA</strong></h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label text-dark">
          <strong>Capacitación:</strong><a class="text-danger">*</a>
        </label>
        <ng-select [items]="capacitaciones" bindLabel="nombre" bindValue="id"
          [(ngModel)]="editAsistenciaForm.capacitacion_id" [disabled]="modoEmbebido" placeholder="Seleccione..."
          [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-4">
        <label class="form-label text-dark">
          <strong>N° Documento:</strong><a class="text-danger">*</a>
        </label>
        <input type="number" class="form-control" [(ngModel)]="editAsistenciaForm.cedula" />
      </div>

      <div class="col-md-4">
        <label class="form-label text-dark">
          <strong>Nombre Completo:</strong><a class="text-danger">*</a>
        </label>
        <input type="text" class="form-control text-uppercase" [(ngModel)]="editAsistenciaForm.nombre" />
      </div>

      <div class="col-md-4">
        <label class="form-label text-dark"><strong>Calificación:</strong></label>
        <input type="number" class="form-control" [(ngModel)]="editAsistenciaForm.calificacion" />
      </div>

      <div class="col-md-4">
        <label class="form-label text-dark"><strong>Asistió:</strong></label>
        <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre" bindValue="id"
          [(ngModel)]="editAsistenciaForm.asistio" [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-4">
        <label class="form-label text-dark"><strong>Aprobado:</strong></label>
        <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre" bindValue="id"
          [(ngModel)]="editAsistenciaForm.aprobado" [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-12">
        <label class="form-label text-dark"><strong>Observaciones:</strong></label>
        <textarea rows="4" class="form-control" [(ngModel)]="editAsistenciaForm.observaciones"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarEdicionAsistencia()">
      <span *ngIf="!loading">Actualizar</span>
      <span *ngIf="loading">Guardando...</span>
    </button>
  </div>
</ng-template>

<ng-template #createAsistenciaModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0"><strong>NUEVA ASISTENCIA</strong></h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-4" *ngIf="!modoEmbebido">
        <label class="form-label">
          <strong>Capacitación:</strong><a class="text-danger">*</a>
        </label>
        <ng-select [items]="[{
            id: selectedProgramacionId,
            nombre: selectedProgramacionCapacitacionNombre
          }]" bindLabel="nombre" bindValue="id" [(ngModel)]="newAsistenciaForm.capacitacion_id"
          placeholder="Seleccione..." [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-4">
        <label class="form-label">
          <strong>N° Documento:</strong><a class="text-danger">*</a>
        </label>
        <input type="number" class="form-control" placeholder="Ej. 1098765432" [(ngModel)]="newAsistenciaForm.cedula" />
      </div>

      <div class="col-md-4">
        <label class="form-label">
          <strong>Nombre Completo:</strong><a class="text-danger">*</a>
        </label>
        <input type="text" class="form-control text-uppercase" placeholder="Ej. Juan Pérez"
          [(ngModel)]="newAsistenciaForm.nombre" />
      </div>

      <div class="col-md-4">
        <label class="form-label"><strong>Calificación:</strong></label>
        <input type="number" class="form-control" [(ngModel)]="newAsistenciaForm.calificacion" />
      </div>

      <div class="col-md-4">
        <label class="form-label"><strong>Asistió:</strong></label>
        <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre" bindValue="id"
          [(ngModel)]="newAsistenciaForm.asistio" [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-4">
        <label class="form-label"><strong>Aprobado:</strong></label>
        <ng-select [items]="[{ id: 1, nombre: 'Sí' }, { id: 0, nombre: 'No' }]" bindLabel="nombre" bindValue="id"
          [(ngModel)]="newAsistenciaForm.aprobado" [clearable]="false">
        </ng-select>
      </div>

      <div class="col-md-12">
        <label class="form-label"><strong>Observaciones:</strong></label>
        <textarea rows="4" class="form-control" [(ngModel)]="newAsistenciaForm.observaciones"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarNuevaAsistencia()">
      <span *ngIf="!loading">Guardar</span>
      <span *ngIf="loading">Guardando...</span>
    </button>
  </div>
</ng-template>

<ng-template #agregarInvitadosModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title mb-0">
      <strong>
        AGREGAR INVITADOS
        <span *ngIf="selectedProgramacionCapacitacionNombre">
          – {{ selectedProgramacionCapacitacionNombre }}
        </span>
      </strong>
    </h5>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <label class="form-label">
      <strong>Agregar invitado por cédula:</strong>
    </label>

    <div class="input-group">
      <input class="form-control" type="number" placeholder="Ingrese el número de documento" [(ngModel)]="cedulaBuscada"
        [disabled]="buscandoInvitado" (keyup.enter)="buscarInvitadoPorCedula()" />
      <button class="btn btn-outline-primary" type="button" [disabled]="buscandoInvitado"
        (click)="buscarInvitadoPorCedula()">
        <i class="fa fa-search" *ngIf="!buscandoInvitado"></i>
        <span *ngIf="buscandoInvitado" class="spinner-border spinner-border-sm"></span>
      </button>
    </div>

    <!-- PERSONA NO ENCONTRADA -->
    <div class="border border-warning rounded p-3 mt-3" *ngIf="personaNoEncontrada">
      <p class="text-warning mb-2">
        <i class="fa fa-exclamation-triangle me-1"></i>
        No se encontró ninguna persona con esa cédula.
        Puedes agregarla manualmente:
      </p>
      <div class="row g-2">
        <div class="col-md-4">
          <input type="number" class="form-control" placeholder="Cédula" [(ngModel)]="nuevoInvitadoManual.cedula" />
        </div>
        <div class="col-md-5">
          <input type="text" class="form-control text-uppercase" placeholder="Nombre completo"
            [(ngModel)]="nuevoInvitadoManual.nombre" />
        </div>
        <div class="col-md-3 d-flex">
          <button class="btn btn-success me-2" type="button" (click)="agregarInvitadoManual()">
            <i class="fa fa-plus"></i> Agregar
          </button>
          <button class="btn btn-outline-secondary" type="button" (click)="cancelarAgregarManual()">Cancelar</button>
        </div>
      </div>
    </div>

    <!-- LISTADO -->
    <div class="mt-3" *ngIf="invitadosSeleccionados.length > 0">
      <h6>Invitados agregados:</h6>
      <table class="table table-sm table-bordered mb-0">
        <thead class="bg-primary text-white">
          <tr>
            <th>N° Documento</th>
            <th>Nombre</th>
            <th width="80" class="text-center">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let inv of invitadosSeleccionados">
            <td>{{ inv.cedula }}</td>
            <td class="text-uppercase">{{ inv.nombre }}</td>
            <td class="text-center">
              <button class="btn btn-sm btn-danger" type="button" (click)="eliminarInvitado(inv.cedula)">
                <i class="fa fa-times"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="loading" (click)="guardarNuevosInvitados()">
      <span *ngIf="!loading">Guardar</span>
      <span *ngIf="loading">Guardando...</span>
    </button>
  </div>
</ng-template>